import {
  useCallback, useMemo,
} from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from '~/_shared/utils/hooks';
import {
  activeMapElementsSetActiveLocationList, activeMapElementsSetActiveMasterKey,
} from '~/store/frontendState/activeMapElements/activeMapElements.actionCreators';
import {
  useIsLocationListOpen, useIsMasterKeyActive,
} from '~/store/frontendState/activeMapElements/activeMapElements.selectors';
import { getMapKeyTypeDisplayName } from '../masterKey/masterKey.helpers';
import { MapKeyType } from '../masterKey/masterKey.types';
import { SidebarTabsComponent } from './sidebarTabs.component';

export const SidebarMapKeyTabsContainer = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const isLocationKeyActive = useIsLocationListOpen();
  const isMasterKeyActive = useIsMasterKeyActive();

  const tabs = useMemo(() => [
    {
      name: getMapKeyTypeDisplayName(MapKeyType.MasterKey, t),
      onSelect: () => {
        dispatch(activeMapElementsSetActiveMasterKey());
      },
    }, {
      name: getMapKeyTypeDisplayName(MapKeyType.LocationList, t),
      onSelect: () => {
        dispatch(activeMapElementsSetActiveLocationList());
      },
    },
  ] as const, [dispatch, t]);

  const onSetActiveTabIndex = useCallback((index: number) => {
    tabs[index]?.onSelect();
  }, [tabs]);

  return (
    <SidebarTabsComponent
      activeTabIndex={isLocationKeyActive ? 1 : isMasterKeyActive ? 0 : undefined}
      tabs={tabs}
      setActiveTabIndex={onSetActiveTabIndex}
    />
  );
};
